// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1hyDd","col":"styles_col__vIy_i"};